<template>
	<el-row class="mainOnebox">
		<!-- 标题 -->
		<el-row class="mainOnebox_title">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>PRODUCT</el-breadcrumb-item>
				<el-breadcrumb-item>Anti-slip Strip</el-breadcrumb-item>
			</el-breadcrumb>
		</el-row>
		<!-- 内容 -->
		<el-row class="mainOnebox_main">
			<div class="mainOnebox_main_list_remove" v-for="(item,i) in imgdata" :key="i" @click="routelist(i)" @mouseenter="changeActive($event)" @mouseleave="removeActive($event)">
				<img :src="item.url">
				<span class="mainOnebox_main_list_name">{{item.title}}</span>
			</div>
			<div class="mainOnebox_main_list_none"></div>
			<div class="mainOnebox_main_list_none"></div>
		</el-row>
	</el-row>
</template>

<script>
	export default {
		components: {
			// banner:banner,
		},
		data() {
			return {
				imgdata: [
					{url: require('@/assets/image/productType/Anti-slipStrip/HZ-B4003.jpg'),title: 'HZ-B4003',list1:'280*35*25*5.0mm + φ6*13mm',list2:'Brass',list3:'Grooves / lines on top',list4:'High polished / mirror finish',list5:'Milling',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Anti-slipStrip/HZ-B5003.jpg'),title: 'HZ-B5003',list1:'280*35*25*4.5mm + φ6*13mm',list2:'Stainless steel',list3:'Grooves / lines on top',list4:'PVD coating',list5:'Milling',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Anti-slipStrip/HZ-B5006.jpg'),title: 'HZ-B5006',list1:'280*35*25*4.5mm + φ6*15mm',list2:'Stainless steel',list3:'Grooves / lines on top',list4:'Brushed / hair-lines',list5:'Milling',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Anti-slipStrip/HZ-B5021.jpg'),title: 'HZ-B5021',list1:'290*25*15*4.5mm + φ6*15mm',list2:'Stainless steel + PU',list3:'Grooves / lines on top',list4:'Brushed / hair-lines',list5:'Milling +injection',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Anti-slipStrip/HZ-B5024.jpg'),title: 'HZ-B5024',list1:'390*25*12*3.2mm',list2:'Stainless steel',list3:'Smooth surface',list4:'Brushed / hair-lines',list5:'Milling',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Anti-slipStrip/HZ-B5026.jpg'),title: 'HZ-B5026',list1:'290*25*15*4.5mm + φ6*15mm',list2:'Stainless steel',list3:'Diamond surface / sunflower',list4:'Brushed / hair-lines',list5:'Milling ',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Anti-slipStrip/HZ-B5029.jpg'),title: 'HZ-B5029',list1:'290*25*15*4.5mm + φ6*15mm',list2:'Stainless steel + PU',list3:'Grooves / lines on top',list4:'Brushed / hair-lines',list5:'Milling',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Anti-slipStrip/HZ-B5046.jpg'),title: 'HZ-B5046',list1:'280*25*15*4.5mm + φ6*15mm',list2:'Stainless steel',list3:'Diamond surface / sunflower',list4:'Brushed / hair-lines + PVD coating',list5:'Milling',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Anti-slipStrip/HZ-B5049.jpg'),title: 'HZ-B5049',list1:'280*35*25*3.2mm',list2:'Stainless steel',list3:'Smooth surface with holes',list4:'Brushed / hair-lines',list5:'Milling',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Anti-slipStrip/HZ-B5054.jpg'),title: 'HZ-B5054',list1:'285*25*15*4.5mm + φ6*15mm',list2:'Stainless steel',list3:'Diamond surface / sunflower',list4:'Brushed / hair-lines',list5:'Etching',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Anti-slipStrip/HZ-B5056.jpg'),title: 'HZ-B5056',list1:'285*35*3.0mm',list2:'Stainless steel',list3:'Diamond surface / sunflower',list4:'Brushed / hair-lines',list5:'Casting',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Anti-slipStrip/HZ-B5061.jpg'),title: 'HZ-B5061',list1:'280*35*25*5.0mm',list2:'Stainless steel',list3:'Brass',list4:'list4',list5:'Milling',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Anti-slipStrip/HZ-B5064.jpg'),title: 'HZ-B5064',list1:'280*35*25*5.0mm',list2:'Stainless steel',list3:'Carborundum rough pattern',list4:'Brushed / hair-lines',list5:'Milling with Carborundum insert',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Anti-slipStrip/HZ-B5101.jpg'),title: 'HZ-B5101',list1:'290*35*25*5.0mm + φ6*19mm',list2:'PU / Nylon / ABS',list3:'Grooves on top',list4:'Matte surface',list5:'Injection',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Anti-slipStrip/HZ-B5106.jpg'),title: 'HZ-B5106',list1:'290*35*25*5.0mm + φ6*19mm',list2:'PU / Nylon / ABS',list3:'Grooves and circles on top',list4:'Matte surface',list5:'Injection',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Anti-slipStrip/HZ-B5888.jpg'),title: 'HZ-B5888',list1:'290*35*25*5.0mm + φ6*13mm',list2:'Stainless steel',list3:'Brushed / hair-lines',list4:'Luminescent insert',list5:'Hezone Tile',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Anti-slipStrip/HZ-B5999.jpg'),title: 'HZ-B5999',list1:'280*35*25*5.0mm + φ6*13mm',list2:'Stainless steel',list3:'Casting diamond surface',list4:'Brushed / hair-lines',list5:'Casting ',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Anti-slipStrip/HZ-B5666.jpg'),title: 'HZ-B5666',list1:'280*35*25*5.0mm + φ6*13mm',list2:'Stainless steel',list3:'Lines on top surface and bevel',list4:'Brushed / hair-lines',list5:'Milling',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Anti-slipStrip/HZ-B5777.jpg'),title: 'HZ-B5777',list1:'280*35*25*5.0mm + φ6*13mm',list2:'Stainless steel',list3:'Casting diamond surface',list4:'Brushed / hair-lines',list5:'Casting',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Anti-slipStrip/HZ-T4011.jpg'),title: 'HZ-T4011',list1:'300*35*25*4.5mm',list2:'PU / Nylon / PP',list3:'Short lines on top',list4:'Matte surface',list5:'Injection',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
				],
				imgDatalis:1,//是从哪个分类进来的
			}
		},
		created() {
			this.setSessionData()
		},
		methods: {
			routelist(i) {
				this.$router.push({
					path: '/productList',
					query: {
						id: i,
						imgDataIndex:this.imgDatalis,//是从哪个分类进来的
					}
				})
			},
			changeActive(e) {
				e.currentTarget.className = 'mainOnebox_main_list';
			},
			removeActive(e) {
				e.currentTarget.className = 'mainOnebox_main_list_remove';
			},
			setSessionData(){
				sessionStorage.setItem('imgData'+this.imgDatalis,JSON.stringify(this.imgdata))
			}
		},

	}
</script>

<style lang="less" scoped>
	@vw: 19.2vw;

	.mainOnebox {
		background: url(~@/assets/image/home/home_bg1.jpg);

		.mainOnebox_title {
			width: 100%;
			padding-left: 7vw;
			margin: 0 auto;
			title-align: center;
			margin-top: 80/@vw;
			margin-bottom: 50/@vw;

			/deep/.el-breadcrumb {
				font-size: 24/@vw;
			}
		}

		.mainOnebox_main {
			max-width: 1530px;
			margin: 0 auto;
			height: auto;
			padding-bottom: 100/@vw;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: row;
			flex-wrap: wrap;

			.mainOnebox_main_list {
				width: 350px;
				height: 350px;
				margin: 1vh 1.5vw;
				position: relative;
				overflow: hidden;
				cursor: pointer;

				img {
					width: 350px;
					height: 350px;
					position: relative;
				}

				.mainOnebox_main_list_name {
					position: absolute;
					bottom: 0;
					height: 100%;
					width: 100%;
					font-weight: 700;
					color: #fafafa;
					width: 100%;
					z-index: 999;
					left: 0;
					display: flex;
					align-items: center;
					justify-content: center;
					background-color: #000000;
					background-color: rgba(51, 51, 51, 0.5);
					font-size: 20px;
					transition: all 0.5s ease 0s;
					cursor: pointer;
				}
			}
			.mainOnebox_main_list_remove {
				width: 350px;
				height: 350px;
				margin: 1vh 1.5vw;
				position: relative;
				overflow: hidden;
				cursor: pointer;

				img {
					width: 350px;
					height: 350px;
					position: relative;
				}

				.mainOnebox_main_list_name {
					display: none;
				}
			}
			.mainOnebox_main_list_none {
				width: 350px;
				margin: 1vh 1.5vw;
				height: 0px;
			}
		}
	}
</style>
